export default __webpack_public_path__ + "static/media/right-rotate.fcb32031.svg";